const DETAIL_CACHE_TTL_MS = 30 * 60 * 1000;
const DETAIL_CACHE_MAX = 200;

const store = new Map();
const inflight = new Map();

export const readDetailCache = (key) => {
  const hit = store.get(key);
  if (!hit) return undefined;
  if (hit.expiresAt <= Date.now()) {
    store.delete(key);
    return undefined;
  }
  return hit.value;
};

export const writeDetailCache = (key, value) => {
  if (value == null) return;
  if (store.size >= DETAIL_CACHE_MAX && !store.has(key)) {
    const first = store.keys().next().value;
    if (first) store.delete(first);
  }
  store.set(key, { value, expiresAt: Date.now() + DETAIL_CACHE_TTL_MS });
};

/** Reuse a successful detail response for 30 minutes. Failures are not stored. */
export const withDetailCache = (key, loader) => {
  const hit = readDetailCache(key);
  if (hit !== undefined) return Promise.resolve(hit);

  const pending = inflight.get(key);
  if (pending) return pending;

  const request = Promise.resolve()
    .then(loader)
    .then((value) => {
      inflight.delete(key);
      if (value != null) writeDetailCache(key, value);
      return value;
    })
    .catch((error) => {
      inflight.delete(key);
      throw error;
    });

  inflight.set(key, request);
  return request;
};
